/**
 * @author: yd+zhanghj
 * @recentUpdate: 2019-07-18
 * @Time: 15:52
 * @CopyRight sr  All rights reserved
 * @Notice: 该文件结合实际需求对axios进行了二次封装，如在此文件做任何改动请详细写明目的(注释),否则出现问题后果自负
 * @Tip: 特别注意axios必须要是0.18.0以下版本的,否则_options自定义参数不生效
 */
import store from '../store'
import axios from 'axios'
import { Loading, Message, MessageBox } from 'element-ui'
// import {setErrorLogs} from '@/utils/auth.js';

function myAxios(axiosConfig,opt) {
  const service = axios.create({
    baseURL: process.env.BASE_API,
    timeout: 20000
  })
  var loading = ''
  /* 自定义参数
       * _options:{
            loading_flag: 是否显示加载Icon,默认为true
            loading_text: 加载Icon文字,默认:玩命请求中...
            loading_icon: 自定义loadinIcon:https://element.eleme.cn/#/zh-CN/component/icon
            show_error: 是否展示接口非零时的错误提示
        }
       **/

  var _options = {
    loading_flag: true,
    loading_text: '请求中...',
    loading_icon: '',
    show_error: true
  }
// request拦截器
  service.interceptors.request.use(
    config => {
      for (let key in config._options) {
        if (config._options[key] !== undefined) {
          _options[key] = config._options[key]
        }
      }
      if(opt){
        for (let key in opt) {
          if (opt[key] !== undefined) {
            _options[key] = opt[key];
          }
        }
      }
      // 开启遮罩层
      if (_options.loading_flag) {
        loading = Loading.service({
          lock: true,
          text: _options.loading_text,
          spinner: _options.loading_icon,
          background: 'rgba(255, 255, 255, 0.5)'
        })
      }
      return config
    }
  )
// response 拦截器
  service.interceptors.response.use(
    response => {
      if (loading !== '') {
        loading.close()
      }
      if (response.data.code !== 0 && _options.show_error) {
        Message({
          message: response.data.message ? response.data.message : '数据请求异常',
          type: 'error',
          duration: 5 * 1000
        })
      }
      return response
    },
    error => {
      if (error && error.response) {
        switch (error.response.status) {
          case 400:
            error.message = '请求错误'
            break
          case 401:
            MessageBox.confirm(
              '你已被登出，可以取消继续留在该页面，或者重新登录',
              '确定登出',
              {
                confirmButtonText: '重新登录',
                cancelButtonText: '取消',
                type: 'warning'
              }
            ).then(() => {
              store.dispatch('FedLogOut').then(() => {
                location.reload()
              })
            })
            error.message = '未授权，请登录'
            break
          case 403:
            error.message = '拒绝访问'
            break
          case 404:
            error.message = `请求地址出错: ${error.response.config.url}`
            break
          case 408:
            error.message = '请求超时'
            break
          case 500:
            error.message = '服务器内部错误'
            break
          case 501:
            error.message = '服务未实现'
            break
          case 502:
            error.message = '网关错误'
            break
          case 503:
            error.message = '服务不可用'
            break
          case 504:
            error.message = '网关超时'
            break
          case 505:
            error.message = 'HTTP版本不受支持'
            break
          default:
            break
        }
      }
      if (error.message.includes('timeout')) {
        error.message = '网络请求超时'
      }
      Message({
        message: error.message,
        type: 'error',
        duration: 5 * 1000
      });
      // setErrorLogs({
      //   url: axiosConfig.url,
      //   mainInfo: JSON.stringify(axiosConfig) + '------' + JSON.stringify(error.message) + '------' + error.response.status,
      //   hook: 'hook axios'
      // });
      if (loading !== '') {
        loading.close()
      }
      return Promise.reject(error)
    }
  );
  return service(axiosConfig);
}

export default myAxios



// WEBPACK FOOTER //
// ./src/api/axios.js